// extracted by mini-css-extract-plugin
export var chevron = "_mg-4";
export var chevronExpanded = "_mg-5";
export var row = "_mg-0";
export var rowBody = "_mg-6";
export var rowDescription = "_mg-7";
export var rowHeader = "_mg-1";
export var rowTitle = "_mg-2";
export var rowTitleComplete = "_mg-3";